module.exports = __webpack_public_path__ + "stylesheets/landing-template_b841ab2ae7a2946160255753c779ea09.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/landing-template.less
// module id = dy9G
// module chunks = 151